const appReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_IMAGES":
            return {
                ...state,
                images: action.payload,
                isLoading: false,
            };
        case "SHUFFLE_IMAGES":
            return {
                ...state,
                images: action.payload,
            };
        case "GET_EVENTS":
            return {
                ...state,
                events: action.payload,
                isLoading: false,
            };
        case "GET_RESOURCES":
            return {
                ...state,
                resources: action.payload,
                isLoading: false,
            };
        case "GET_RESOURCE":
            return {
                ...state,
                isLoading: false,
            };
        case "GET_EVENT":
            return {
                ...state,
                isLoading: false,
            };
        case "GET_HOME_CONTENT":
            return {
                ...state,
                links: action.payload.links.map((link) => {
                    const imgURL = get_youtube_thumbnail(link.link, "max");
                    return { ...link, imgURL };
                }),
                quotes: action.payload.quotes.map((quote) => quote.quote),
                announcements: action.payload.announcements,
                isLoading: false,
            };
        case "GET_ANNOUNCEMENTS":
            return {
                ...state,
                announcements: action.payload,
                isLoading: false,
            };
        case "GET_QUOTES":
            return {
                ...state,
                quotes: action.payload,
                isLoading: false,
            };
        case "GET_LINKS":
            return {
                ...state,
                links: action.payload.map((link) => {
                    const imgURL = get_youtube_thumbnail(link.link, "max");
                    return { ...link, imgURL };
                }),
                isLoading: false,
            };
        case "GET_TEAMS":
            return {
                ...state,
                teams: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default appReducer;

function get_youtube_thumbnail(url, quality) {
    if (url) {
        var video_id, thumbnail, result;
        if ((result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/))) {
            video_id = result.pop();
        } else if ((result = url.match(/youtu.be\/(.{11})/))) {
            video_id = result.pop();
        }

        if (video_id) {
            if (typeof quality === "undefined") {
                quality = "high";
            }

            var quality_key = "maxresdefault"; // Max quality
            if (quality === "low") {
                quality_key = "sddefault";
            } else if (quality === "medium") {
                quality_key = "mqdefault";
            } else if (quality === "high") {
                quality_key = "hqdefault";
            }

            thumbnail =
                "http://img.youtube.com/vi/" +
                video_id +
                "/" +
                quality_key +
                ".jpg";
            return thumbnail;
        }
    }
    return false;
}
